const topics = [
  { label: '繁花全集', heat: '985万' },
  { label: '庆余年第二季', heat: '967万' },
  { label: '狂飙经典', heat: '942万' },
  { label: '古装仙侠推荐', heat: '856万' },
  { label: '2024热播剧', heat: '823万' },
  { label: '悬疑剧推荐', heat: '798万' },
  { label: '都市情感剧', heat: '754万' },
  { label: '高分国产剧', heat: '721万' },
  { label: '日韩剧精选', heat: '698万' },
  { label: '不缓冲追剧', heat: '675万' },
  { label: '高清全集在线', heat: '643万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-600 text-xs font-medium mb-3">
            <i className="ri-hashtag"></i>
            大家都在搜
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">小草影院用户正在关注的热门话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">#{topic.label}</span>
              <span className="text-[10px] text-accent-500 font-semibold whitespace-nowrap">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}